import React from "react";

const RefundCancellationPolicy = () => {
  return (
    <>
      <section
        style={{
          paddingTop: "108px",
          background: "linear-gradient(135deg, #1f3c88 0%, #39a0ed 100%)",
        }}
      >
        <div className="auto-container">
          <div style={{ padding: "42px 0 36px", textAlign: "center", color: "#ffffff" }}>
            <h1 style={{ fontSize: "40px", fontWeight: 700, marginBottom: "8px", color: "#ffffff" }}>
              Refund &amp; Cancellation Policy - Asysta India Private Limited
            </h1>
          </div>
        </div>
      </section>

      <section
        style={{
          background: "linear-gradient(180deg, #eef4ff 0%, #ffffff 100%)",
          padding: "42px 0 80px",
        }}
      >
        <div className="auto-container">
          <div
            style={{
              maxWidth: "980px",
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: "14px",
              boxShadow: "0 12px 30px rgba(15, 39, 73, 0.10)",
              border: "1px solid #e4ebf7",
              padding: "38px 32px",
              color: "#2a2a2a",
              lineHeight: "1.75",
            }}
          >
            <p style={{ marginBottom: "14px", color: "#5c6675", fontWeight: 600 }}>Last Updated: [28/05/2026]</p>
            <p>Thank you for choosing Asysta (“we”, “our”, “us”). This Refund &amp; Cancellation Policy explains how refunds, cancellations, and rescheduling work for bookings made through <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a> (“Website”).</p>
            <p>By making a booking on our Website, you agree to the terms below.</p>

            <p><strong>1. Nature of Our Service</strong><br />
              Asysta is a platform that connects users with independent, third-party driving schools (“Service Providers”). We facilitate:<br />
              Course discovery<br />
              Booking<br />
              Payments<br />
              Communication<br />
              Support<br />
              However, all driving training services are delivered by the respective driving school, not by Asysta.
            </p>

            <p><strong>2. Refund Eligibility</strong><br />
              Refunds depend on the policy of the driving school you booked with.<br />
              A refund may be issued if:<br />
              The driving school cancels the course<br />
              The driving school is unable to provide the service<br />
              The user cancels within the driving school’s allowed cancellation window<br />
              There is a duplicate payment or technical error<br />
              Asysta will process refunds only after receiving confirmation from the driving school.
            </p>

            <p><strong>3. Non-Refundable Situations</strong><br />
              Refunds will not be provided if:<br />
              The user fails to attend scheduled classes<br />
              The user provides incorrect information during booking<br />
              The user requests cancellation after the driving school’s allowed window<br />
              The user is dissatisfied with instructor behaviour, training quality, or vehicle condition (these must be resolved directly with the driving school)<br />
              The user changes their mind after the course has started<br />
              Asysta is not responsible for service quality or training outcomes.
            </p>

            <p><strong>4. Cancellation Policy</strong></p>

            <p><strong>4.1 User-Initiated Cancellations</strong><br />
              Users may request cancellation through:<br />
              Their Asysta account<br />
              Email<br />
              WhatsApp support (if available)<br />
              Approval depends on the driving school’s policy.
            </p>

            <p><strong>4.2 Driving School-Initiated Cancellations</strong><br />
              If the driving school cancels due to:<br />
              Instructor unavailability<br />
              Vehicle issues<br />
              Operational reasons<br />
              Weather or safety concerns<br />
              You may be offered:<br />
              A rescheduled session, or<br />
              A refund (as per the school’s policy)
            </p>

            <p><strong>5. Rescheduling</strong><br />
              Rescheduling is subject to:<br />
              Availability of the driving school<br />
              Their internal rules<br />
              Advance notice requirements<br />
              Asysta will assist in coordinating rescheduling but cannot guarantee availability.
            </p>

            <p><strong>6. Refund Processing Time</strong><br />
              Once approved by the driving school:<br />
              Refunds are processed by Asysta within 7–10 business days<br />
              Payment gateway timelines may vary<br />
              Refunds are issued to the original payment method<br />
              Asysta is not responsible for delays caused by banks or payment gateways.
            </p>

            <p><strong>7. Payment Gateway Charges</strong><br />
              In some cases, payment gateways may deduct:<br />
              Transaction fees<br />
              Convenience charges<br />
              Processing fees<br />
              These charges are non-refundable, unless the driving school explicitly approves full reimbursement.
            </p>

            <p><strong>8. No Guarantee of Training Outcomes</strong><br />
              Refunds will not be issued for:<br />
              Failure to pass the Learner’s Licence or Driving Licence test<br />
              Dissatisfaction with training progress<br />
              Personal expectations not met<br />
              Driving performance depends on individual learning ability and the driving school’s training methods.
            </p>

            <p><strong>9. Dispute Resolution</strong><br />
              If you face issues with a driving school:<br />
              Contact the driving school directly<br />
              If unresolved, contact Asysta support<br />
              We will mediate between both parties<br />
              However, Asysta’s decision is final regarding refund eligibility.
            </p>

            <p><strong>10. Changes to This Policy</strong><br />
              We may update this Refund &amp; Cancellation Policy at any time. Changes will be posted on this page with an updated “Last Updated” date.<br />
              Continued use of the Website means you accept the updated policy.
            </p>

            <p><strong>11. Contact Us</strong><br />
              For refund or cancellation requests, contact us at:<br />
              <i className="fas fa-envelope" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="mailto:info@asysta.in">[Info@asysta.in]</a>
              <span style={{ display: "inline-block", width: "14px" }}></span>
              <i className="fas fa-globe" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default RefundCancellationPolicy;
